/**
 * English (GBP) mock transactions. Transfer pairs carry the same `paired*`
 * fields the app's groupTransferPairs() produces, so the real DoubleRow
 * component renders the two-sided sublines.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_TRANSACTIONS_EN = [
	{
		id: 'txn-1',
		date: '2026-08-03',
		type: 'Deposit',
		amount: 2400,
		description: 'Salary',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Income',
	},
	{
		id: 'txn-2',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Transfer',
		amount: 500,
		description: 'To savings',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Savings',
		pairedType: 'Transfer',
		pairedAmount: 500,
		pairedCurrencySymbol: '\u00A3',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: 'Savings',
		pairedAccountId: 'acc-savings',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-3',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Regular Investment',
		amount: 500,
		description: 'ISA top-up',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Investing',
		pairedType: 'Regular Investment',
		pairedAmount: 500,
		pairedCurrencySymbol: '\u00A3',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: 'Stocks & Shares ISA',
		pairedAccountId: 'acc-broker',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-4',
		isTransferPair: true,
		date: '2026-07-20',
		type: 'Credit Card Payment',
		amount: 1240,
		description: 'Rewards Card direct debit',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Bills',
		pairedType: 'Credit Card Payment',
		pairedAmount: 1240,
		pairedCurrencySymbol: '\u00A3',
		pairedCurrencyDecimalPlaces: 2,
		pairedAccountName: 'Rewards Card',
		pairedAccountId: 'acc-credit',
		pairedDate: '2026-07-20',
	},
	{
		id: 'txn-5',
		date: '2026-07-24',
		type: 'Withdrawal',
		amount: 100,
		description: 'Cash machine',
		accountId: 'acc-checking',
		accountName: 'Royal Bank',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Cash',
	},
	{
		id: 'txn-6',
		date: '2026-07-22',
		type: 'Purchase',
		amount: 54,
		description: 'Supermarket',
		accountId: 'acc-credit',
		accountName: 'Rewards Card',
		currency: 'GBP',
		currencySymbol: '\u00A3',
		currencyDecimalPlaces: 2,
		tagNames: 'Food',
	},
	{
		id: 'txn-7',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: 'Flight bonus',
		accountId: 'acc-flight',
		accountName: 'Flight Mileage',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'Miles',
	},
];

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_AVIOS_TRANSACTIONS_EN = [
	{
		id: 'av-1',
		date: '2026-08-02',
		type: 'Reward Earned',
		amount: 5600,
		description: 'Hotel stay bonus',
		accountId: 'acc-flight',
		accountName: 'Flight Mileage',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'Miles',
	},
	{
		id: 'av-2',
		date: '2026-07-28',
		type: 'Reward Redemption',
		amount: 20000,
		description: 'Reward flight, Economy',
		accountId: 'acc-flight',
		accountName: 'Flight Mileage',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'Travel',
	},
	{
		id: 'av-3',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: 'Flight bonus',
		accountId: 'acc-flight',
		accountName: 'Flight Mileage',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: 'Miles',
	},
];
